import { useMemo } from "react";
import { IOption } from "../../../types/Option";
import { KPI_CODES } from "../kpiCodes";

export const useAmountsWidget = (data: any) => {
  const incidentOptions = useMemo(
    () => [
      { value: 1, label: "Today" },
      { value: 2, label: "This Month" },
      { value: 3, label: "Previous Month" },
    ],
    [],
  );

  const incidentAmounts: IOption[] | null = useMemo(() => {
    if (data) {
      const value = data.kpiValues
        .filter((item: any) =>
          [
            KPI_CODES.INCIDENTS_COUNT_TODAY,
            KPI_CODES.INCIDENTS_COUNT_THIS_MONTH,
            KPI_CODES.INCIDENTS_COUNT_PREV_MONTH,
          ].includes(item.code),
        )
        .map((item: any) => ({
          label:
            item.code === KPI_CODES.INCIDENTS_COUNT_TODAY
              ? 1
              : item.code === KPI_CODES.INCIDENTS_COUNT_THIS_MONTH
                ? 2
                : 3,
          value: item.value,
        }));

      return value;
    }

    return null;
  }, [data]);

  return { incidentOptions, incidentAmounts };
};
